import CommonProperties from "./commonProperties";
class EdgeSourceAdditionalInfo extends CommonProperties {
    constructor(Created, Description, Color, GroupId, FromNodeName, ToNodeName) {
        super(Created, Description, Color);
        this.GroupId = GroupId;
        this.FromNodeName = FromNodeName;
        this.ToNodeName = ToNodeName;
    }
}
export default EdgeSourceAdditionalInfo;
